import $ from 'jquery';
import loadGoogleMapsApi from './load-google-maps-api-facade';
import { safeHtml } from 'common-tags';

/**
 * JSON style from https://mapstyle.withgoogle.com/
 */
const stylesArray = [
	{
	  "elementType": "geometry",
	  "stylers": [
		{
		}
	  ]
	}
];

const $locationsMaps = $( '.js-locations-map' );

$locationsMaps.each( function() {
	let $map = $( this ).find( '.js-locations-map__map' );
	let locations = $( this ).data( 'locations' );

	loadGoogleMapsApi( { key: WP.apiKeys.googleMaps } ).then( function( googleMaps ) {

		let map = new googleMaps.Map( $map[0], {
			zoom: 7,
			center: new googleMaps.LatLng( 39, -100 ),
			mapTypeId: googleMaps.MapTypeId.ROADMAP,
			styles: stylesArray,
			disableDefaultUI: true,
			gestureHandling: 'cooperative'
		} );

		googleMaps.event.addListenerOnce( map, 'tilesloaded', function() {
			let infoWindow = new googleMaps.InfoWindow( {
				content: 'loading...',
				maxWidth: 400
			} );

			let markers = [];

			locations.forEach( ( location, i ) => {
				let marker = new googleMaps.Marker( {
					position: new googleMaps.LatLng( location.location.lat, location.location.lng ),
					map: map,
					icon: {
						url: WP.paths.templateDirectoryUri + '/assets/images/icon/pin-green.png',
						scaledSize: new google.maps.Size( 29, 46 )
					},
				} );

				markers.push( marker );

				googleMaps.event.addListener( marker, 'click', () => {
					infoWindow.close();
					infoWindow.setContent( '<div class="c-locations__popup-container"><h6>' + location.title + '</h6><p>' + location.content + '</p></div>' );
					infoWindow.open( map, marker );
				} );
			} );

			if (markers.length < 2) {
				google.maps.event.trigger(markers[0], 'click');
			}

			// make markers fit in map
			let bounds = new googleMaps.LatLngBounds();
			markers.forEach( ( marker ) => {
				bounds.extend( marker.getPosition() );
			} );

			// expand bounds a little
			let extendPoint1 = new googleMaps.LatLng(
				bounds.getNorthEast().lat() + 0.01,
				bounds.getNorthEast().lng() + 0.01
			);
			let extendPoint2 = new googleMaps.LatLng(
				bounds.getNorthEast().lat() - 0.01,
				bounds.getNorthEast().lng() - 0.01
			);
			bounds.extend( extendPoint1 );
			bounds.extend( extendPoint2 );

			map.fitBounds( bounds );
		} );
	} ).catch( function( error ) {
		console.error( error );
	} );
} );
